import { useContext, useEffect } from 'react'

import SchoolsContext from '../contexts/Schools'
import School from '../models/School'
import useCurrentUser from './useCurrentUser'
import {
	updateSchool,
	updateSchoolUserData,
	removeSchool,
	setIsObservingSchools
} from '../actions'
import { compose2, compose3 } from '../utils'

export default () => {
	const [{ enrolledSchools, isObservingEnrolledSchools }, dispatch] = useContext(SchoolsContext)
	
	const [currentUser] = useCurrentUser()
	
	useEffect(() => {
		if (!currentUser || isObservingEnrolledSchools)
			return
		
		dispatch(setIsObservingSchools(true, true))
		
		School.observeForUserWithId(currentUser.id, true, {
			updateSchool: compose3(dispatch, updateSchool),
			updateSchoolUserData: compose2(dispatch, updateSchoolUserData),
			removeSchool: compose2(dispatch, removeSchool)
		})
	}, [currentUser, isObservingEnrolledSchools]) // eslint-disable-line
	
	return enrolledSchools
}
